export default {
  API_APP_ID: 'tabacalera_website',
  API_URL: 'https://api-altadisbrandsites.tusaapi.com',
  FRONT_END_URL: 'https://www.tabacalerausa.com',
  CDN_URL: '',
  GA_TRACKING_ID: ''
};



// WEBPACK FOOTER //
// ./src/config/production.ts